
import { computed } from '@nuxtjs/composition-api';
import { storeToRefs } from 'pinia';
import { useChosenVariantDetailsStore } from '~/stores/useChosenVariantDetailsStore';
import useUtilities from '~/composable/useUtilities';
export default {
  props: {
    hasSpecialPrices: {
      type: Boolean,
      default: false
    },
    productName: {
      type: String,
      default: ''
    }
  },
  setup() {
    const chosenVariantDetailsStore = useChosenVariantDetailsStore()
    const {
      chosenInstallment,
      chosenChannel
    } = storeToRefs(chosenVariantDetailsStore)
    const { formatPrice } = useUtilities()
    return {
      formatPrice,
      chosenChannel,
      discount: computed(() => chosenChannel.value?.productBundlePrice?.discount),
      basePrice: computed(() => chosenChannel.value?.productBundlePrice?.basePrice),
      bindingPeriodPayment: computed(() => chosenChannel.value?.productBundlePrice?.bindingPeriodPayment),
      minimumPrice: computed(() => chosenChannel.value?.productBundlePrice?.minimumPrice),
      productWithSubscriptionPrice: computed(() => chosenChannel.value?.productBundlePrice?.productWithSubscriptionPrice),
      cashPrice: computed(() => chosenChannel.value?.productBundlePrice?.cashPrice),
      monthlyAmountWithSubscription: computed(() => chosenInstallment.value?.monthlyAmountWithSubscription),
      chosenInstallmentPeriod: computed(() => chosenInstallment.value?.months),
      isCash: computed(() => chosenChannel.value?.channelKey === 'Cash'),
      bundlePrice: computed(() => chosenChannel.value?.productBundlePrice?.bundlePrice)
    }
  }
}
